import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import auth from './modules/auth'
import handbook from './modules/handbook'

const store = new Vuex.Store({
  modules: {
    auth,
    handbook
  }
})

export default store
